import React from 'react';
import { Map } from 'immutable';
import c from 'classnames';
import { ImageFromField } from '@uncinc/react-drupal-core';

import {
  SCREEN_NORMAL,
} from '../../config/constants';

import './style.scss';
import WysiwygField from '../WysiwygField';
import FormattedLink from '../FormattedLink';

const CTA = ({ title, text, link, image }) => {
  const classNames = c('CTA', 'o-background--grey', {
    'CTA--text-only': !image,
  });

  return (
    <div className={classNames}>
      <div className="CTA__text">
        <h2 className="h3">{ title }</h2>
        <WysiwygField
          property="schema:text"
          html={text}
        />
        <FormattedLink link={link} />
      </div>
      { image && (
        <div className="CTA__image">
          <ImageFromField
            field={image}
            imageStyles={Map({
              [SCREEN_NORMAL]: 'original_optimized',
            })}
            lazyload
          />
        </div>
      )}
    </div>
  );
};

export default CTA;
